import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/design.css'
import { track } from '../lib/events'

// Fires when the user adds the site to their home screen (PWA install).
window.addEventListener('appinstalled', () => track('pwa-app-installed'))

function trackNotificationOpened(path) {
  track('notification-opened', { path })
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'notification-opened') {
      trackNotificationOpened(event.data.path)
    }
  })
}

const params = new URLSearchParams(window.location.search)
if (params.get('notification') === 'opened') {
  trackNotificationOpened(window.location.pathname)
  params.delete('notification')
  const query = params.toString()
  window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`)
}

// Service worker scope defaults to "/" because it is served from the root.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker'))
}

createInertiaApp({
  // Without this callback Inertia's head manager commits an empty element
  // list on boot and strips the server-rendered <title data-inertia>, leaving
  // the tab showing the bare URL.
  title: (title) => (title ? `${title} · Cabreiros Cup` : 'Cabreiros Cup'),
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    return pages[`../pages/${name}.jsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
